// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"18f5ac46","995":"a765ebb1"}[chunkId] + ".css";
};